/* eslint-env browser */
import * as React from 'react'

import { extractArticleFullName, getModelAndArticleFromProduct } from '../../../../../../shared/services/gear-service'
import analytics from '../../../../common/client/analytics'
import { publish } from '../../services/pub-sub'
import withTranslator from '../TranslatorProvider'

const axios = require('axios')
const PropTypes = require('prop-types')
const classNames = require('classnames')

const ShareModal = require('../Modals/ShareModal')
const MediaCarousel = require('../Catches/MediaCarousel')
const StarsDisplay = require('../Notes/StarsDisplay')
const CatchesGrid = require('../CatchesGrid/Grid')
const GridFilter = require('./GridFilter')
const SpecsList = require('./SpecsList')
const SpeciesGrid = require('../Species/SpeciesGrid')
const GearsGrid = require('../SideCards/GearsGrid')
const UsersGrid = require('../UsersGrid/Grid')
const OpinionsList = require('../Opinions/OpinionsList')
const PubSub = require('../../../../client/clientjs/services/pub-sub')
const ModalsHelper = require('../../../../client/clientjs/utils/modals')

function getModel(modelSeoName, product, previouslySelectedArticle) {
  if (!product) {
    return {}
  }
  let selectedModel
  let selectedArticle

  for (let i = 0; i < product.models.length; i++) {
    const model = product.models[i]
    if (model.seoName === modelSeoName) {
      selectedModel = model
      if (previouslySelectedArticle) {
        for (let j = 0; j < model.articles.length; j++) {
          const article = model.articles[j]
          if (article.name === previouslySelectedArticle.name) {
            selectedArticle = article
            break
          }
        }
      }
      break
    }
  }

  if (!selectedModel) {
    ;[selectedModel] = product.models
  }
  if (selectedModel && !selectedArticle) {
    ;[selectedArticle] = selectedModel.articles
  }
  return {
    selectedModel,
    selectedArticle,
  }
}

class FullGear extends React.Component {
  constructor(props) {
    super(props)

    const {
      product,
      selectedProductArticleSeoName,
      articleCatches,
      modelCatches,
      productCatches,
      species,
      mostAssociatedGear,
      latestUsers,
      opinions,
      opinionsGlobalNote,
      currentUserOpinion,
    } = props
    const { selectedModel, selectedArticle } = getModelAndArticleFromProduct(selectedProductArticleSeoName, product)

    this.state = {
      selectedModel,
      selectedArticle,
      isModalVisible: false,
      modalOpts: {},
      loadingDetails: false,
      articleCatches,
      modelCatches,
      productCatches,
      species,
      mostAssociatedGear,
      latestUsers,
      opinions,
      opinionsGlobalNote,
      currentUserOpinion,
    }

    this.didSelectProductModel = this.didSelectProductModel.bind(this)
    this.didSelectProductArticle = this.didSelectProductArticle.bind(this)
    this.onClickShare = this.onClickShare.bind(this)
    this.onHideModal = this.onHideModal.bind(this)
    this.updateDynamicDatas = this.updateDynamicDatas.bind(this)
  }

  componentDidMount() {
    this.eventId = PubSub.sub('fullGearProductArticleDidChange', ({ args }) => {
      const { paSeoName } = args
      const { product } = this.props
      const { selectedModel, selectedArticle } = getModelAndArticleFromProduct(paSeoName, product)
      this.setState({ selectedModel, selectedArticle }, this.updateDynamicDatas)
    })

    const { selectedArticle } = this.state
    const { isLoggedIn } = this.props
    if (!isLoggedIn && selectedArticle.id) {
      setTimeout(() => {
        window._sendPecheurPromoCodeWhenRegistering = true
        window._sendPecheurPromoCodeWhenRegisteringProductArticleId = selectedArticle.id
        ModalsHelper.open('#modal-signup', { showFFRegisterIncentive: true })
      }, 3000)
    }
  }

  componentWillUnmount() {
    PubSub.unsub('fullGearProductArticleDidChange', this.eventId)
  }

  onClickShare(modalOpts) {
    this.setState({ isModalVisible: true, modalOpts })
  }

  onHideModal() {
    this.setState({ isModalVisible: false })
  }

  didSelectProductModel(newValue) {
    const { product, onChangeSelectedArticle } = this.props
    const { selectedArticle: previouslySelectedArticle } = this.state
    const { selectedModel, selectedArticle } = getModel(newValue, product, previouslySelectedArticle)
    this.setState({ selectedModel, selectedArticle }, this.updateDynamicDatas)
    if (onChangeSelectedArticle) {
      onChangeSelectedArticle(selectedArticle.seoName)
    }
  }

  didSelectProductArticle(newValue) {
    const { product, onChangeSelectedArticle } = this.props
    const { selectedModel, selectedArticle } = getModelAndArticleFromProduct(newValue, product)
    this.setState({ selectedModel, selectedArticle }, this.updateDynamicDatas)
    if (onChangeSelectedArticle) {
      onChangeSelectedArticle(selectedArticle.seoName)
    }
  }

  updateDynamicDatas() {
    const { product } = this.props
    const { selectedModel, selectedArticle } = this.state

    publish('updatePecheurComProduct', {
      model: selectedModel,
    })

    this.setState({ loadingDetails: true })
    axios
      .get(`/api/renderProps/gear/${product.seoName}`, {
        params: {
          pa: selectedArticle.seoName,
        },
      })
      .then(response => {
        const {
          articleCatches = [],
          modelCatches = [],
          productCatches = [],
          species = [],
          mostAssociatedGear = [],
          latestUsers = [],
          opinions = [],
          opinionsGlobalNote = {},
          currentUserOpinion = null,
        } = response.data || {}
        this.setState({
          articleCatches,
          modelCatches,
          productCatches,
          species,
          mostAssociatedGear,
          latestUsers,
          loadingDetails: false,
          opinions,
          opinionsGlobalNote,
          currentUserOpinion,
        })
      })
  }

  render() {
    const { isLoggedIn, host, product, brand, productCategory, translate, locale } = this.props

    const {
      loadingDetails,
      selectedModel,
      selectedArticle,
      isModalVisible,
      modalOpts,
      articleCatches,
      modelCatches,
      productCatches,
      species,
      mostAssociatedGear,
      latestUsers,
      opinions,
      opinionsGlobalNote,
      currentUserOpinion,
    } = this.state

    let pecheurComTargetLink = ((selectedModel.supplierData || [])[0] || {}).pecheurPageUrl
    try {
      if (pecheurComTargetLink.match(/^(https:\/\/)?(www\.)?pecheur\.com(.*)/i)) {
        if (pecheurComTargetLink.includes('#1022137')) {
          pecheurComTargetLink = pecheurComTargetLink.replace('#1022137', '#af=1022137')
        } else if (!pecheurComTargetLink.includes('#af=1022137')) {
          pecheurComTargetLink = `${pecheurComTargetLink}#af=1022137`
        }
      }
    } catch (err) {}
    let decathlonOffers = []
    if (!pecheurComTargetLink) {
      decathlonOffers = (selectedModel.supplierData || [])
        .concat(selectedArticle.supplierData || [])
        .filter(elt => {
          return !!elt.decathlonAffiliation
        })
        .map(elt => elt.decathlonAffiliation)
    }

    const allCatches = articleCatches
      .concat(modelCatches)
      .concat(productCatches)
      .slice(0, 6)

    const productFullName = extractArticleFullName({
      productName: product.name,
      modelName: selectedModel.name,
      articleName: selectedArticle.name,
    })

    if (!product || !selectedModel || !selectedArticle) {
      return <div>Well isnt it something wrong going on here?</div>
    }

    let allSpecs = product.specs.concat(selectedModel.specs).concat(selectedArticle.specs)
    allSpecs = allSpecs.reduce((aggreg, spec) => {
      aggreg[spec.specId] = spec
      return aggreg
    }, {})
    allSpecs = Object.values(allSpecs)

    const modelsSortOptions = product.models.map(model => {
      const { selectedArticle: zeArticle } = getModel(model.seoName, product, selectedArticle)
      return {
        key: model.id,
        value: zeArticle.seoName,
        display: model.name.toUpperCase(),
      }
    })
    const articlesSortOptions = selectedModel.articles.map(article => ({
      key: article.id,
      value: article.seoName,
      display: article.name.toUpperCase(),
    }))

    const onClickPecheurCodeRegisterToFF = () => {
      window._sendPecheurPromoCodeWhenRegistering = true
      window._sendPecheurPromoCodeWhenRegisteringProductArticleId = selectedArticle.id
      ModalsHelper.open('#modal-signup', { showFFRegisterIncentive: true })
    }

    return (
      <div
        className="columns is-multiline has-background-white large-shadow-left"
        itemScope
        itemType="http://schema.org/Product"
      >
        <div className="column is-5 is-order-1-tablet">
          <div className="column is-12">
            <nav className="breadcrumb is-small" aria-label="breadcrumbs">
              <ul>
                <li>
                  <a href="/gear/brands">
                    <span>{translate('menu.gear')}</span>
                  </a>
                </li>
                <li itemProp="brand" itemScope itemType="http://schema.org/Brand">
                  <a href={`/gear/brands/${brand.seoName}`} itemProp="url">
                    <span itemProp="name">{brand.name}</span>
                  </a>
                </li>
                <li itemProp="category">
                  <a href={`/gear/brands/${brand.seoName}?productCategoriesIds[]=${productCategory.id}`}>
                    {productCategory.name}
                  </a>
                </li>
              </ul>
            </nav>
            <h1
              className="title is-size-4-desktop is-size-5-tablet is-size-6-mobile has-text-primary-blue"
              itemProp="name"
            >
              {productFullName}
            </h1>
            <div className="subtitle">
              <p className="content">
                <StarsDisplay
                  note={Number(opinionsGlobalNote.average)}
                  maxNote={5}
                  count={Number(opinionsGlobalNote.nbOpinions)}
                  showNote
                  locale={locale}
                  isAverage
                />
              </p>
            </div>
            <div style={{ position: 'relative' }} className="is-hidden-tablet">
              <MediaCarousel medias={selectedArticle.medias || []} isCover={false} figureClassName="is-3by1" />
            </div>
            <div className={classNames('is-uppercase is-size-7', { 'is-hidden': product.models.length <= 1 })}>
              {`${translate('gear.model')} (${product.models.length})`}
            </div>
            <div className={classNames('is-uppercase', { 'is-hidden': product.models.length <= 1 })}>
              <GridFilter
                buttonClassName="is-uppercase has-text-weight-bold"
                options={modelsSortOptions}
                onChange={this.didSelectProductArticle}
                value={selectedArticle.seoName}
                changeURLQueryParam="pa"
                host={host}
                hostPath={`/gear/products/${product.seoName}`}
              />
            </div>
            <div
              className={classNames('is-uppercase is-size-7 has-padding-top-xsmall', {
                'is-hidden': selectedModel.articles.length <= 1,
              })}
            >
              {`${translate('gear.article')} (${selectedModel.articles.length})`}
            </div>
            <div className={classNames('is-uppercase', { 'is-hidden': selectedModel.articles.length <= 1 })}>
              <GridFilter
                buttonClassName="is-uppercase has-text-weight-bold"
                options={articlesSortOptions}
                onChange={this.didSelectProductArticle}
                value={selectedArticle.seoName}
                changeURLQueryParam="pa"
                host={host}
                hostPath={`/gear/products/${product.seoName}`}
              />
            </div>
            <div className="is-hidden-tablet has-padding-top-small">
              <h2
                className={classNames('has-text-primary-blue has-text-weight-bold', {
                  'is-hidden': allSpecs.length <= 0,
                })}
              >
                {translate('gear.productSpecs.title')}
              </h2>
              <SpecsList specs={allSpecs} locale={locale} />
            </div>
            <div className="buttons is-vertical has-margin-top-medium">
              {/* <button type="button" className="button is-call-to-action is-uppercase is-small">
                <span>
                  {translate('gear.addToTackleBoxButton')}
                </span>
                <span className="icon is-small">
                  <i className="fas fa-archive" />
                </span>
              </button>
              <button type="button" className="button is-link is-outlined is-uppercase is-small">
                <span>
                  {translate('gear.addToWishListButton')}
                </span>
                <span className="icon">
                  <i className="fas fa-heart" />
                </span>
                </button> */}
              <button
                className="button is-small is-primary is-outlined"
                type="button"
                onClick={() =>
                  this.onClickShare({
                    shareableLink: `/gear/products/${product.seoName}?pa=${selectedArticle.seoName}`,
                  })
                }
              >
                <span className="icon">
                  <i className="fas fa-share" />
                </span>
                <span className="has-text-weight-bold">{translate('share')}</span>
              </button>
            </div>
          </div>

          <div className={classNames('column is-12 animated fadeIn faster', { 'is-hidden': !loadingDetails })}>
            <div className="loader is-size-1 is-primary is-self-centered" />
          </div>
          <div className={classNames('column is-12 animated fadeIn faster', { 'is-hidden': loadingDetails })}>
            {pecheurComTargetLink || decathlonOffers.length > 0 ? (
              <>
                <hr />
                <h2 className={classNames('has-text-primary-blue has-text-weight-bold has-padding-bottom-small')}>
                  {translate('gear.offers.title')}
                </h2>
                <div>
                  {decathlonOffers.map(elt => (
                    <div key={elt.displayName} className="has-margin-bottom-small">
                      <div className="media">
                        <div className="media-left has-margin-top-medium">
                          <figure className="image is-64x64-mobile is-64x64-tablet is-128x128-desktop">
                            <a target="_blank" rel="noopener noreferrer" href={elt.page}>
                              <img
                                src="https://statics.fishfriender.com/statics/partners/caperlan_one%20typo.png"
                                target="_blank"
                                alt="Caperlan"
                                className="img-responsive has-object-fit-contain"
                                style={{ width: '100%', paddingLeft: 10, paddingRight: 10 }}
                              />
                            </a>
                          </figure>
                        </div>
                        <div className="media-content is-size-7">
                          <img src={elt.pixel} alt="" />
                          <a target="_blank" rel="noopener noreferrer" href={elt.page}>
                            <div className="subtitle" style={{ fontSize: 13 }}>
                              {elt.displayName}
                            </div>
                            <div className="title has-text-weight-bold" style={{ color: '#4a4a4a', fontSize: 17 }}>
                              {elt.price.amount} €
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                  {pecheurComTargetLink && (
                    <div className="has-margin-bottom-small">
                      <div className="media">
                        <div className="media-left has-margin-horizontal-xsmall">
                          <figure className="image is-32x32-mobile is-64x64-tablet is-square">
                            <a target="_blank" rel="noopener noreferrer" href={pecheurComTargetLink}>
                              <img
                                src="https://statics.fishfriender.com/statics/partners/logo_pecheur_square.png"
                                target="_blank"
                                alt="Pecheur.com"
                                className="img-responsive has-object-fit-contain"
                                style={{ width: '100%', paddingLeft: 10, paddingRight: 10 }}
                              />
                            </a>
                          </figure>
                        </div>
                        <div className="media-content is-size-7">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={pecheurComTargetLink}
                            onClick={analytics.trackEventSimple('clicked-pecheur-affiliate')}
                          >
                            <div className="subtitle" style={{ fontSize: 13 }}>
                              {selectedModel.supplierData[0].pecheurFullName}
                            </div>
                            {selectedModel.articles.length > 0 &&
                              (selectedModel.articles[0].supplierData || []).length > 0 &&
                              selectedModel.articles[0].supplierData[0].pecheurPricesEuro &&
                              selectedModel.articles[0].supplierData[0].pecheurPricesEuro.FR && (
                                <div className="title has-text-weight-bold" style={{ color: '#4a4a4a', fontSize: 17 }}>
                                  {translate('ads.product.price', {
                                    price: selectedModel.articles[0].supplierData[0].pecheurPricesEuro.FR || '',
                                  })}
                                </div>
                              )}
                            <div
                              className="subtitle  has-text-weight-bold has-text-info"
                              style={{ color: '#4a4a4a', fontSize: 17 }}
                            >
                              {'🛒 '}
                              {translate('ads.product.buyOnPecheur')}
                              {' >'}
                            </div>
                          </a>
                        </div>
                      </div>
                      {!isLoggedIn && (
                        <div
                          style={{ cursor: 'pointer' }}
                          className="notification is-warning has-text-black has-text-bold has-margin-top-small"
                          onClick={onClickPecheurCodeRegisterToFF}
                        >
                          <div className="icon-text">
                            <span
                              // eslint-disable-next-line react/no-danger
                              dangerouslySetInnerHTML={{
                                __html: translate('ads.product.pecheurPromoCode.ffRegisterIncentive.notification', {
                                  escape: false,
                                }),
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </>
            ) : (
              undefined
            )}
            <hr />
            <h2 className={classNames('has-text-primary-blue has-text-weight-bold has-padding-bottom-small')}>
              {translate('gear.species.title')}
            </h2>
            <SpeciesGrid species={species} />
            <h2
              className={classNames('has-text-primary-blue has-text-weight-bold has-padding-bottom-small', {
                'is-hidden': (mostAssociatedGear || []).length <= 0,
              })}
            >
              {translate('gear.associatedGear.title')}
            </h2>
            {(mostAssociatedGear || []).length > 0 && <GearsGrid gears={mostAssociatedGear} simpleGrid />}
            <h2
              className={classNames('has-text-primary-blue has-text-weight-bold has-padding-bottom-small', {
                'is-hidden': (latestUsers || []).length <= 0,
              })}
            >
              {translate('gear.users.title')}
            </h2>
            {latestUsers.length > 0 && <UsersGrid users={latestUsers} customItemClassName="is-4" simpleGrid />}
          </div>
        </div>
        <div className="column is-7">
          <div style={{ position: 'relative' }} className="is-hidden-mobile">
            <MediaCarousel medias={selectedArticle.medias || []} isCover={false} figureClassName="is-3by1" />
          </div>
          <div className="column is-12 is-hidden-mobile">
            <h2
              className={classNames('has-text-primary-blue has-text-weight-bold', {
                'is-hidden': allSpecs.length <= 0,
              })}
            >
              {translate('gear.productSpecs.title')}
            </h2>
            <SpecsList specs={allSpecs} locale={locale} />
          </div>
          <div className={classNames('column is-12 animated fadeIn faster', { 'is-hidden': loadingDetails })}>
            <hr />
            <h2 className={classNames('has-text-primary-blue has-text-weight-bold has-padding-bottom-small')}>
              {translate('gear.catches.title')}
            </h2>
            <CatchesGrid
              nonLoadableCatches={allCatches}
              simpleGrid={false}
              locale={locale}
              displayLikes={false}
              isLoggedIn={isLoggedIn}
              customItemClassName="is-2-mobile is-2-tablet is-2-desktop"
            />
          </div>
          {!loadingDetails && (
            <div className="column is-12">
              <hr />
              <h2 className={classNames('has-text-primary-blue has-text-weight-bold')}>
                {translate('gear.opinions.title') +
                  (Number(opinionsGlobalNote.nbOpinions) > 0 ? ` (${opinionsGlobalNote.nbOpinions})` : '')}
              </h2>
              <div className="is-size-7 has-padding-bottom-small">
                <div>{productFullName}</div>
                {selectedArticle.medias.length > 0 && (
                  <img
                    src={
                      selectedArticle.medias[0].url_300 ||
                      selectedArticle.medias[0].url_600 ||
                      selectedArticle.medias[0].url
                    }
                    title={productFullName}
                    alt={productFullName}
                    style={{ maxHeight: 30, maxWidth: 200 }}
                  />
                )}
              </div>
              <OpinionsList
                locale={locale}
                isLoggedIn={isLoggedIn}
                opinions={opinions}
                averageNote={Number(opinionsGlobalNote.average)}
                totalOpinionsCount={Number(opinionsGlobalNote.nbOpinions)}
                opinionable="productArticle"
                opinionableId={selectedArticle.id}
                subtitle={productFullName}
                currentUserOpinion={currentUserOpinion}
                mostRecentOnTop
              />
            </div>
          )}
        </div>
        <ShareModal isActive={isModalVisible} onHide={this.onHideModal} host={host} {...modalOpts} />
      </div>
    )
  }
}

FullGear.propTypes = {
  translate: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  productCategory: PropTypes.object.isRequired,
  selectedProductArticleSeoName: PropTypes.string,
  articleCatches: PropTypes.array,
  modelCatches: PropTypes.array,
  latestUsers: PropTypes.array,
  productCatches: PropTypes.array,
  isLoggedIn: PropTypes.bool,
  species: PropTypes.array,
  mostAssociatedGear: PropTypes.array,
  opinions: PropTypes.array,
  opinionsGlobalNote: PropTypes.object,
  currentUserOpinion: PropTypes.object,
  host: PropTypes.string.isRequired,
  onChangeSelectedArticle: PropTypes.func,
}

FullGear.defaultProps = {
  selectedProductArticleSeoName: null,
  articleCatches: [],
  modelCatches: [],
  productCatches: [],
  latestUsers: [],
  isLoggedIn: false,
  species: [],
  mostAssociatedGear: [],
  opinions: [],
  opinionsGlobalNote: {},
  currentUserOpinion: null,
  onChangeSelectedArticle: null,
}

module.exports = withTranslator(FullGear)
